import { TableBody, TableCell, TableRow } from "@mui/material";
import React from "react";

import { AdminTableLoadingRow } from "./AdminTableLoadingRow";

interface AdminTableBodyStateProps<TItem> {
  items: readonly TItem[];
  isLoading: boolean;
  colSpan: number;
  loadingLabel: React.ReactNode;
  emptyState: React.ReactNode;
  children: (item: TItem) => React.ReactNode;
}

/** Handles the consistent loading, populated, and empty states for admin list tables. */
export const AdminTableBodyState = <TItem,>({
  items,
  isLoading,
  colSpan,
  loadingLabel,
  emptyState,
  children,
}: AdminTableBodyStateProps<TItem>) => (
  <TableBody>
    {isLoading ? (
      <AdminTableLoadingRow colSpan={colSpan} label={loadingLabel} />
    ) : items.length > 0 ? (
      items.map(children)
    ) : (
      <TableRow>
        <TableCell colSpan={colSpan} align="center">
          {emptyState}
        </TableCell>
      </TableRow>
    )}
  </TableBody>
);
